import { useModal } from '../ModalContext';

/**
 * Hook für die einfache Verwendung von Confirm und Alert Modals
 * Ersetzt window.confirm und window.alert mit benutzerfreundlichen Modals
 */
export const useConfirmAlert = () => {
  const { showConfirm, showAlert } = useModal();

  /**
   * Zeigt ein Confirmation Modal
   * @param {string} message - Die Nachricht die angezeigt werden soll
   * @param {object} options - Optionale Konfiguration
   * @param {string} options.title - Titel des Modals (default: "Bestätigung")
   * @param {string} options.confirmText - Text des Bestätigen-Buttons (default: "OK")
   * @param {string} options.cancelText - Text des Abbrechen-Buttons (default: "Abbrechen")
   * @returns {Promise<boolean>} - true wenn bestätigt, false wenn abgebrochen
   */
  const confirm = async (message, options = {}) => {
    return await showConfirm({
      message,
      ...options
    });
  };

  /**
   * Zeigt ein Alert Modal
   * @param {string} message - Die Nachricht die angezeigt werden soll
   * @param {object} options - Optionale Konfiguration
   * @param {string} options.title - Titel des Modals (default: "Information")
   * @param {string} options.confirmText - Text des OK-Buttons (default: "OK")
   * @returns {Promise<void>}
   */
  const alert = async (message, options = {}) => {
    return await showAlert({
      message,
      ...options
    });
  };

  return {
    confirm,
    alert
  };
};